import _      from 'lodash'
import moment from 'moment'
import Model  from 'alto-orm/lib/orm/model'

export default class Product extends Model
  @nominativeName: 'produkt'
  @accusativeName: 'produkt'
